// extracted by mini-css-extract-plugin
module.exports = {"container":"QuoteCard_container__I3Sfj","image":"QuoteCard_image__WKZRM","body":"QuoteCard_body__9iun4"};